export default "__VITE_ASSET__DJTZkXyB__"